// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"DallasTooltipAnchor_tooltip__J5SmI","arrow":"DallasTooltipAnchor_arrow__BYU1Y"};